import { makeAutoObservable } from "mobx";
import ApiStore from "./ApiStore";
import { getMimeImageType } from "../../components/ModalFileViewer/ModalFileViewer";
import FileHelper from "../../helpers/FileHelper";

class ModalViewerStore {

    isOpenModal: boolean = false;
    urlModal: string = "";
    documentName: string = "";
    isLocalFileForIframe: boolean = false;

    private _api: ApiStore;

    constructor(api: ApiStore) {
        makeAutoObservable(this);
        this._api = api;
    }
    openModal = () => {
        this.isOpenModal = true
    }
    dissmissModal = () => {
        this.isOpenModal = false;
    }
    editUrlModal = (newUrlModal: string) => {
        this.urlModal = newUrlModal;
    }
    editDocumentName = (newDocumentName: string) => {
        this.documentName = newDocumentName;
    }
    editIsLocalFileForIframe = (status: boolean) => {
        this.isLocalFileForIframe = status;
    }

    openFileWithLoading = async (dataPromise: Promise<any>, fileName: string, setIsLoading?: (loading: boolean) => void) => {
        if (setIsLoading) setIsLoading(true);
        const newWindow = FileHelper.openLoadingWindow();
        try {
            const data = await dataPromise;
            this.openFileByData(data, fileName, newWindow);
        } catch (error) {
            if (newWindow) newWindow.close();
            console.error("Error loading document: ", error);
        } finally {
            if (setIsLoading) setIsLoading(false);
        }
    }

    openFileByData = (data: any, fileName: string, targetWindow?: Window | null) => {
        const byteArray: number[] = Array.from(atob(data), char => char.charCodeAt(0));
        const mimeIsImage = getMimeImageType(fileName);
        const { isMobileDevice } = FileHelper;
        if (mimeIsImage.mimeType.length && (!mimeIsImage.isPdf || (!isMobileDevice && mimeIsImage.isPdf))) {
            const blob = new Blob([new Uint8Array(byteArray)], { type: mimeIsImage.mimeType })
            const url = URL.createObjectURL(blob);
            this.editUrlModal(url);
            this.editDocumentName(fileName);
            this.editIsLocalFileForIframe(true);
            // this.openModal();
            if (targetWindow) {
                targetWindow.location.href = url;
            } else {
                window.open(url,"_blank");
            }
        } else {
            if (targetWindow) {
                targetWindow.close();
            }
            FileHelper.downloadFile(byteArray, fileName)
        }
    }
    openFileByUrl = (url: string, fileName: string) => {
        const mimeIsImage = getMimeImageType(fileName);
        const { isMobileDevice } = FileHelper;
        if (mimeIsImage.mimeType.length && (!mimeIsImage.isPdf || (!isMobileDevice && mimeIsImage.isPdf))) {
            this.editUrlModal(url)
            this.editDocumentName(fileName)
            this.editIsLocalFileForIframe(false);
            this.openModal();
        } else {
            FileHelper.downloadFileByURL(url, fileName)
        }
    }
    openPageByUrl = (url: string, pageName: string) => {
        this.editUrlModal(url)
        this.editDocumentName(pageName)
        this.editIsLocalFileForIframe(false);
        this.openModal();
    }



}
export default ModalViewerStore